import React from "react";
import { useQuery } from "react-query";
import {
    QUERY_KEY_EXPENSE_CATEGORIES,
    QUERY_KEY_EXPENSE_MANAGERS,
    QUERY_KEY_EXPENSE_USERS_AND_DEPARTMENTS,
} from "./keys";
import {
    _api_get_expense_categories,
    _api_get_expense_managers,
    _api_get_expense_users_and_departments,
} from ".";
import { QUERY_KEY } from "../constants";
import { AVATAR_DEFAULT, AVATAR_DEPARTMENT_DEFAULT } from "../../../constants";

export const useQGetExpenseCategories = () => {
    const { data, isLoading } = useQuery(
        [QUERY_KEY + "::" + QUERY_KEY_EXPENSE_CATEGORIES],
        () => _api_get_expense_categories()
    );
    const categories_formatted = data?.map((cat) => {
        return {
            id: cat?.id,
            key: cat?.id,
            header: cat?.name,
        };
    });
    return {
        data,
        format_data: categories_formatted,
        isLoading,
    };
};

export const useQGetManagers = () => {
    const { data, isLoading } = useQuery(
        [QUERY_KEY + "::" + QUERY_KEY_EXPENSE_MANAGERS],
        () => _api_get_expense_managers()
    );
    const managers_formatted = data?.map((manager) => {
        return {
            id: manager?.id,
            key: manager?.id,
            header: manager?.first_name + " " + manager?.last_name,
            image: manager?.avatar,
            content: manager?.job_title,
        };
    });
    return {
        data,
        format_data: managers_formatted,
        isLoading,
    };
};

export const useQGetExpenseUsersAndDepartments = () => {
    const { data, isLoading } = useQuery(
        [QUERY_KEY + "::" + QUERY_KEY_EXPENSE_USERS_AND_DEPARTMENTS],
        () => _api_get_expense_users_and_departments()
    );

    const USERS = data?.map((user) => {
        return {
            id: user?.id,
            key: user?.id,
            header: user?.name,
            image: user?.avatar
                ? user?.avatar
                : user?.is_department
                ? AVATAR_DEPARTMENT_DEFAULT
                : AVATAR_DEFAULT,
            is_department: user?.is_department,
        };
    });

    return {
        data,
        format_data: USERS,
        isLoading,
    };
};
